import {
  AppliedPayableRestriction,
  DocumentSelectionChangeEvent,
} from '@arc/unified-payments-frontend/shared-payment';
import { createAction, props } from '@ngrx/store';

export const documentSelectionChanged = createAction(
  '[Make Payment Intl Component] Document Selection Changed',
  props<{
    event: DocumentSelectionChangeEvent;
  }>(),
);

export const buyerAccountSelected = createAction(
  '[Make Payment Intl Component] Buyer Account Selected',
  props<{
    buyerAccount: string;
  }>(),
);

export const buyerAccountValidated = createAction(
  '[Make Payment Intl Component] Buyer Account Validated',
);

export const payableRestrictionsApplied = createAction(
  '[Make Payment Intl Component] Payable Restrictions Applied',
  props<{
    payload: AppliedPayableRestriction[];
  }>(),
);

export const signInBannerDismissed = createAction(
  '[Make Payment Intl Component] Sign In Banner Dismissed',
);

export const emailVerificationPendingPopupClosed = createAction(
  '[Make Payment Intl Component] Email Verification Pending Popup Closed',
);

export const continueAsGuestClicked = createAction(
  '[Make Payment Intl Component] Continue As Guest Clicked',
);

export const signInBannerSignedIn = createAction(
  '[Make Payment Intl Component] Sign In Banner Signed In',
  props<{ username: string }>(),
);

export const signInResendLink = createAction(
  '[Make Payment Intl Component] Sign In Resend Link',
);

export const signInChangeUsername = createAction(
  '[Make Payment Intl Component] Sign In Change Username',
);

export const checkAutopayEligibility = createAction(
  '[Make Payment Intl Component] Check Autopay Eligibility',
  props<{
    tenantId: string;
    accountNumbers: string[];
  }>(),
);

export const enrollInAutopayClicked = createAction(
  '[Make Payment Intl Component] Enroll In Autopay Clicked',
);
